// Normalized global pointer shared with the 3D scenes (canvas itself is pointer-events:none).
export const pointer = { x: 0, y: 0 };

if (typeof window !== "undefined") {
    window.addEventListener(
        "pointermove",
        (e) => {
            pointer.x = (e.clientX / window.innerWidth) * 2 - 1;
            pointer.y = -(e.clientY / window.innerHeight) * 2 + 1;
        },
        { passive: true },
    );
}
